module.exports = __webpack_public_path__ + "img/logo.30b1ffe6.png";